import React from 'react';
import { PARAMS } from "../../../../config";

const Head = ({ onSortChange, quality }) => {
    let th = PARAMS.map(([ param, paramName ]) => <th onClick={() => onSortChange(param)} key={param}>{paramName}</th>);

    if(quality) th.push(<th onClick={() => onSortChange(`rD`)} key={`rD`}>Revenue Diff.</th>);

    return (
        <thead>
            <tr>
                <th onClick={() => onSortChange(`a`)}>Affid</th>
                <th onClick={() => onSortChange(`s`)}>Subid</th>
                {th}
            </tr>
        </thead>
    )
};

export default Head;


// WEBPACK FOOTER //
// ./src/scenes/AdKernelDaily/components/Table/components/Head/index.js